import type { ArticleDto } from '../dto/article.dto'
import type { Article } from '@/domain/entities/article.entity'
import { mapDate } from './base.mapper'

/**
 * Маппер ArticleDto (бэкенд) -> Article (Domain Entity)
 */
export function mapArticleDtoToEntity(dto: ArticleDto): Article {
  return {
    id: dto._id,
    article_slug: dto.article_slug,
    article_title: dto.article_title,
    article_image: dto.article_image ?? '',
    article_content: dto.article_content ?? [],
    article_author: {
      name: dto.article_author?.name ?? '',
      photo: dto.article_author?.photo,
    },
    article_views: dto.article_views ?? 0,
    article_related_course_ids: dto.article_related_course_ids ?? [],
    article_locale: dto.article_locale,
    article_seo_keywords: dto.article_seo_keywords ?? [],
    article_created_at: mapDate(dto.article_created_at),
    article_modified_at: mapDate(dto.article_modified_at),
  }
}

/**
 * Маппер массива ArticleDto -> Article[]
 */
export function mapArticleDtoArrayToEntities(dtos: ArticleDto[]): Article[] {
  return dtos.map(mapArticleDtoToEntity)
}
